import C from  '../constants/search';
import {dispatchAjaxResponseWithCharger} from '../utils/helpers';

export function setSearch(keyword) {
    return (dispatch) => {
        dispatch({
            type: C.SET_SEARCH_KEYWORD,
            payload: keyword
        });
    }
}

export function getSearchData(keyword) {
    keyword = encodeURIComponent(keyword);
    let url = `api/v1/sc/search?query=${keyword}`;
    return dispatchAjaxResponseWithCharger(url,C.GET_SEARCH_DATA);

    // const searchData = {
    //     order: ['serviceCatalog', 'sr', 'faq', 'categories', 'templates'],
    //     itemsPerSource: 5,
    //     sr: [
    //         {
    //             id: 999999999,
    //             title: 'where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!wh',
    //             date: '1/2/99',
    //             status: 'Pending PM',
    //             requestUser: 'Shushu Hashual'
    //         },
    //         {
    //             id: 2414,
    //             title: 'sr title 2',
    //             date: '10/12/16',
    //             status: 'Open',
    //             requestUser: ''
    //         },
    //         {
    //             id: 31,
    //             title: 'sr title 2',
    //             date: '26/4/17',
    //             status: 'Closed'
    //         }
    //     ],
    //     faq: [
    //         {
    //             id: 1,
    //             title: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standardLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standardLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standardLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standardLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standardLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book',
    //             userTopicViews: 6712,
    //             voteYes:892,
    //             updateTime: '11/12/99'
    //         },
    //
    //         {
    //             id: 2,
    //             title: 'Lorem Ipsum ',
    //             userTopicViews: 1112,
    //             voteYes:2132,
    //             updateTime: '1/2/99'
    //         },
    //         {
    //             id: 3,
    //             title: 'faq  title 1',
    //             userTopicViews: 12,
    //             voteYes:2,
    //             updateTime: '1/2/99'
    //         },
    //         {
    //             id: 4,
    //             title: 'faq  title 2',
    //             userTopicViews: 12,
    //             voteYes:2,
    //             updateTime: '1/2/99'
    //         }
    //     ],
    //     categories: [
    //         {
    //             id: 1,
    //             firstLevelCategoryCaption:'Application ABC',
    //             secondLevelCategoryCaption:'',
    //             thirdLevelCategoryCaption:'',
    //             incidentEnabled: true,
    //             requestEnabled: false
    //         },
    //         {
    //             id: 2,
    //             firstLevelCategoryCaption:'Mobile Devices where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!',
    //             secondLevelCategoryCaption:'Tablet',
    //             thirdLevelCategoryCaption:'Other',
    //             incidentEnabled: true,
    //             requestEnabled: true
    //         },
    //         {
    //             id: 3,
    //             firstLevelCategoryCaption:'Other Equipment',
    //             secondLevelCategoryCaption:'Faxes',
    //             thirdLevelCategoryCaption:'',
    //             incidentEnabled: false,
    //             requestEnabled: true
    //         }
    //     ],
    //     templates: [
    //         {
    //             id: 2281,
    //             templateName: 'where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!where is my icon?!',
    //             type: 'incident'
    //         },
    //         {
    //             id: 19,
    //             templateName: 'Add paper',
    //             type: 'request'
    //         },
    //         {
    //             id: 5148,
    //             templateName: 'Just another very long title Just another very long title Just another very long title Just another very long title ',
    //             type: 'request'
    //         }
    //     ],
    //     serviceCatalog: [
    //         {
    //             type: 'CATEGORY_POINTER',
    //             guestEnabled: false,
    //             id: 535,
    //             name: 'ddfg',
    //             enabled: true,
    //             systemItem: false,
    //             uniqueName: null,
    //             description: '',
    //             order: 1,
    //             iconPath: '/icons/ssp/default_icon.svg',
    //             customIcon: false,
    //             parent: 0,
    //             guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //             enablenessHint: '',
    //             userVisibilityHint: '',
    //             userGroups: [
    //                 'ALL_SYSAID_USERS'
    //             ],
    //             excludeUserGroups: [],
    //             companies: [
    //                 0
    //             ],
    //             excludeCompanies: [],
    //             firstLevelCategory: 12338,
    //             secondLevelCategory: 0,
    //             thirdLevelCategory: 0,
    //             children: [
    //                 {
    //                     id: 14388,
    //                     name: 'kuku',
    //                     type: 'CATEGORY_INFO',
    //                     children: [
    //                         {
    //                             id: 13,
    //                             name: 'Permissions to use printer',
    //                             type: 'REQUEST_TEMPLATE_LINK',
    //                             'description': 'Permissions to use printer'
    //                         },
    //                         {
    //                             id: 2239,
    //                             name: 'Submit Request',
    //                             type: 'SUBMIT_REQUEST'
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     id: 16420,
    //                     name: 'llll',
    //                     type: 'CATEGORY_INFO',
    //                     children: [
    //                         {
    //                             id: 16422,
    //                             name: 'service catalog',
    //                             type: 'CATEGORY_INFO',
    //                             children: [
    //                                 {
    //                                     id: 11,
    //                                     name: 'Check trimmed  ',
    //                                     type: 'FAQ_ITEM',
    //                                     'votes': 0,
    //                                     'views': 22
    //                                 },
    //                                 {
    //                                     id: 2234,
    //                                     name: 'Submit Request',
    //                                     type: 'SUBMIT_REQUEST'
    //                                 }
    //                             ]
    //                         },
    //                         {
    //                             id: 13,
    //                             name: 'test 31945',
    //                             type: 'FAQ_ITEM',
    //                             'votes': 1,
    //                             'views': 18
    //                         },
    //                         {
    //                             id: 2230,
    //                             name: 'Submit Request',
    //                             type: 'SUBMIT_REQUEST'
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     id: 13389,
    //                     name: 'sub_cat0',
    //                     type: 'CATEGORY_INFO',
    //                     children: [
    //                         {
    //                             id: 14459,
    //                             name: 'third_level_cat0',
    //                             type: 'CATEGORY_INFO',
    //                             children: [
    //                                 {
    //                                     id: 225,
    //                                     name: 'Submit Request',
    //                                     type: 'SUBMIT_REQUEST'
    //                                 }
    //                             ]
    //                         }
    //                     ]
    //                 },
    //                 {
    //                     id: 1339,
    //                     name: 'tutu',
    //                     type: 'REQUEST_TEMPLATE_LINK',
    //                     'description': 'tutu description'
    //                 },
    //                 {
    //                     id: 2231,
    //                     name: 'Submit Request',
    //                     type: 'SUBMIT_REQUEST'
    //                 }
    //             ]
    //         },
    //         {
    //             type: 'FOLDER',
    //             guestEnabled: false,
    //             id: 210,
    //             name: 'Inner Folder',
    //             enabled: true,
    //             systemItem: false,
    //             uniqueName: null,
    //             description: '',
    //             order: 2,
    //             iconPath: '/FILESYSTEM/test/icons/ssp/toolbox_cust_icon_210_1527682651594.jpg',
    //             customIcon: true,
    //             parent: 167,
    //             guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //             enablenessHint: '',
    //             userVisibilityHint: '',
    //             userGroups: [
    //                 'ALL_SYSAID_USERS'
    //             ],
    //             excludeUserGroups: [],
    //             companies: [
    //                 0
    //             ],
    //             excludeCompanies: [],
    //             children: [
    //                 {
    //                     type: 'CATEGORY_POINTER',
    //                     guestEnabled: false,
    //                     id: 480,
    //                     name: 'Inner category pointer1111111111',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'ttttt',
    //                     order: 1,
    //                     iconPath: '/FILESYSTEM/test/icons/ssp/toolbox_cust_icon_480_1527682642837.jpg',
    //                     customIcon: true,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     firstLevelCategory: 12444,
    //                     secondLevelCategory: 0,
    //                     thirdLevelCategory: 0,
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 8,
    //                     name: 'My Desktop',
    //                     enabled: true,
    //                     systemItem: true,
    //                     uniqueName: 'myDesktop',
    //                     description: 'Access your computer anywhere, anytime from the device of your choice',
    //                     order: 2,
    //                     iconPath: '/icons/ssp/my-desktop.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: null,
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/EndUserRemoteAccess.jsp?noframe=YES&ssp=YES',
    //                     openingMethod: 'NEW_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 8,
    //                     name: 'My Desktop',
    //                     enabled: true,
    //                     systemItem: true,
    //                     uniqueName: 'myDesktop',
    //                     description: 'Access your computer anywhere, anytime from the device of your choice',
    //                     order: 2,
    //                     iconPath: '/icons/ssp/my-desktop.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: null,
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/EndUserRemoteAccess.jsp?noframe=YES&ssp=YES',
    //                     openingMethod: 'NEW_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 8,
    //                     name: 'My Desktop',
    //                     enabled: true,
    //                     systemItem: true,
    //                     uniqueName: 'myDesktop',
    //                     description: 'Access your computer anywhere, anytime from the device of your choice',
    //                     order: 2,
    //                     iconPath: '/icons/ssp/my-desktop.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: null,
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/EndUserRemoteAccess.jsp?noframe=YES&ssp=YES',
    //                     openingMethod: 'NEW_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 8,
    //                     name: 'My Desktop',
    //                     enabled: true,
    //                     systemItem: true,
    //                     uniqueName: 'myDesktop',
    //                     description: 'Access your computer anywhere, anytime from the device of your choice',
    //                     order: 2,
    //                     iconPath: '/icons/ssp/my-desktop.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: null,
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/EndUserRemoteAccess.jsp?noframe=YES&ssp=YES',
    //                     openingMethod: 'NEW_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 8,
    //                     name: 'My Desktop',
    //                     enabled: true,
    //                     systemItem: true,
    //                     uniqueName: 'myDesktop',
    //                     description: 'Access your computer anywhere, anytime from the device of your choice',
    //                     order: 2,
    //                     iconPath: '/icons/ssp/my-desktop.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: null,
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/EndUserRemoteAccess.jsp?noframe=YES&ssp=YES',
    //                     openingMethod: 'NEW_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 49,
    //                     name: 'Google Inbox',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 5,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 },
    //                 {
    //                     type: 'LINK',
    //                     guestEnabled: false,
    //                     id: 151,
    //                     name: 'My Settings',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Keep your settings up to date, manage your contact details, language settings and more!',
    //                     order: 3,
    //                     iconPath: '/icons/ssp/my-settings.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         0
    //                     ],
    //                     excludeCompanies: [],
    //                     targetUrl: '/mySettings',
    //                     openingMethod: 'CURRENT_WINDOW',
    //                     supportedForAccount: true,
    //                     sampleItem: false
    //                 },
    //                 {
    //                     type: 'FOLDER',
    //                     guestEnabled: false,
    //                     id: 345,
    //                     name: 'Google Inbox(1)',
    //                     enabled: true,
    //                     systemItem: false,
    //                     uniqueName: null,
    //                     description: 'Inbox by Gmail is a new app from the Gmail team. Inbox is an organized place to get things done and get back to what matters. Bundles keep emails organized',
    //                     order: 4,
    //                     iconPath: '/icons/ssp/default_icon.svg',
    //                     customIcon: false,
    //                     parent: 210,
    //                     guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //                     enablenessHint: '',
    //                     userVisibilityHint: '',
    //                     userGroups: [
    //                         'ALL_SYSAID_USERS'
    //                     ],
    //                     excludeUserGroups: [],
    //                     companies: [
    //                         1,
    //                         2
    //                     ],
    //                     excludeCompanies: [],
    //                     children: []
    //                 }
    //             ]
    //         },
    //         {
    //             type: 'LINK',
    //             guestEnabled: true,
    //             id: 2,
    //             name: 'Submit a Request><',
    //             enabled: true,
    //             systemItem: true,
    //             uniqueName: 'submitRequest',
    //             description: 'Have an IT request or missing any functionality? Click here to submit a service record to your IT department.{<<sdasdHave an IT request or missing any functionality? Click here to submit a service record to your IT department.{<<sdasdHave an IT request or missing any functionality? Click here to submit a service record to your IT department.{<<sdasdHave an IT request or missing any functionality? Click here to submit a service record to your IT department.{<<sdasdHave an IT request or missing any functionality? Click here to submit a service record to your IT department.{<<sdasd',
    //             order: 4,
    //             iconPath: '/icons/ssp/submit-requset_green.svg',
    //             customIcon: false,
    //             parent: 0,
    //             guestEnabledCheckboxLabelKey: 'ssp.service.catalog.form.visibleToGuest.caption',
    //             enablenessHint: '',
    //             userVisibilityHint: '',
    //             userGroups: [
    //                 'aaa',
    //                 'd\'r',
    //                 '{aaa'
    //             ],
    //             excludeUserGroups: [
    //                 'EU4ever',
    //                 'EUGroup',
    //                 '{bbb'
    //             ],
    //             companies: [
    //                 0
    //             ],
    //             excludeCompanies: [],
    //             targetUrl: '/submitSR',
    //             openingMethod: 'CURRENT_WINDOW',
    //             supportedForAccount: true,
    //             sampleItem: false
    //         }
    //     ]
    // };
    //
    // return (dispatch) => {
    //     dispatch({
    //         type: C.GET_SEARCH_DATA,
    //         payload: searchData
    //     });
    // }
}


export function changeFilter(newFilter) {
    return (dispatch) => {
        dispatch({
            type: C.CHANGE_FILTER,
            payload: newFilter
        });
    }
}


// WEBPACK FOOTER //
// ./actions/search.js